import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';
import { BehaviorSubject } from 'rxjs';

export type InternalStateType = {
  [key: string]: any
};

@Injectable({
  providedIn: 'root'
})
export class AppState {
  _body={
    "email": "shahid@codeforgeek.com",
    "name": "Shahid"
  }
  _state: InternalStateType = {};
  _tourData;
  private _navigationNotify = new BehaviorSubject<string>('');
  readonly _navigationNotify$ = this._navigationNotify.asObservable();
  accounts_api: any;
  gate2b_api: any;
  constructor(private httpClient: HttpClient) {
  }

  setLocalStorageFunctions() {
    Storage.prototype.getEncryptedItem = function (item) {
      if (item) {
        try{
          let encodedKey = btoa(item);
          let itemValue = localStorage.getItem(encodedKey);
          if (itemValue) {
            return atob(itemValue);
          }
        }
        catch {
          let encodedKey = toBase64(item);
          let itemValue = localStorage.getItem(encodedKey);
          if (itemValue) {
            return fromBase64(itemValue);
          }
        }
      }
      return null;
    }
    Storage.prototype.setEncryptedItem = function (item, itemValue) {
      if (item && itemValue) {
        try {
          let encodedKey = btoa(item);
          let encodedValue = btoa(itemValue);
          localStorage.setItem(encodedKey, encodedValue);
          return true;
        }
        catch {
          let encodedKey = toBase64(item);
          let encodedValue = toBase64(itemValue);
          localStorage.setItem(encodedKey, encodedValue);
          return true;
        }
      }
      return false;
    }
    Storage.prototype.removeEncryptedItem = function (item) {
      if (item) {
        try {
          let encodedKey = btoa(item);
          localStorage.removeItem(encodedKey);
          return true;
        }
        catch {
          let encodedKey = toBase64(item);
          localStorage.removeItem(encodedKey);
          return true;
        }
      }
      return false;
    }
    this.accounts_api = localStorage.getEncryptedItem('API_END_POINT_ACCOUNTS');
    this.gate2b_api = localStorage.getEncryptedItem('API_END_POINT_GATE2B');
  }
  //  setLocalStorageFunctions() {
  //   Storage.prototype.getEncryptedItem = function (item) {
  //     if (item) {
  //       let encodedKey = toBase64(item);
  //       let itemValue = localStorage.getItem(encodedKey);
  //       if (itemValue) {
  //         return fromBase64(itemValue);
  //       }
  //     }
  //     return null;
  //   }
  //   Storage.prototype.setEncryptedItem = function (item, itemValue) {
  //     if (item && itemValue) {
  //       let encodedKey = toBase64(item);
  //       let encodedValue = toBase64(itemValue);
  //       localStorage.setItem(encodedKey, encodedValue);
  //       return true;
  //     }
  //     return false;
  //   }
  //   Storage.prototype.removeEncryptedItem = function (item) {
  //     if (item) {
  //       let encodedKey = toBase64(item);
  //       localStorage.removeItem(encodedKey);
  //       return true;
  //     }
  //     return false;
  //   }
  //   this.accounts_api = localStorage.getEncryptedItem('API_END_POINT_ACCOUNTS');
  //   this.gate2b_api = localStorage.getEncryptedItem('API_END_POINT_GATE2B');
  // }

  createAccessToken(){
    return  this.httpClient.post(localStorage.getEncryptedItem('API_END_POINT_ACCOUNTS')+'users/createAccessToken',{}).pipe(map((response:Response)=>response))
  }
  getUserProfile(data){
    return this.httpClient.post(localStorage.getEncryptedItem('API_END_POINT_ACCOUNTS')+"/profile",'',{ withCredentials: true }).pipe(map((response: Response) => response));
  }
  getTourListData(data){
    return this.httpClient.post(localStorage.getEncryptedItem('API_END_POINT_GATE2B')+"gate2bAPI/tourList",data).pipe(map((response:Response)=>response))
  }
  setTourData(data){
    this._tourData = data;
  }
  getTourData(){
    return this._tourData;
  }
  updateTour(data){
    return this.httpClient.post(this.gate2b_api+"gate2bAPI/updateTour",data).pipe(map((response:Response)=>response))
  }
  updateTutorialStatus(data){
    return this.httpClient.post(this.gate2b_api+"gate2bAPI/updateTutorialStatus",data).pipe(map((response:Response)=>response))

  }
  notify(data) {
    this._navigationNotify.next(data);
  }

  getWhiteLabelConfig(data){
    return  this.httpClient.post(localStorage.getEncryptedItem('API_END_POINT_ACCOUNTS')+'auth/getWhiteLabelConfig',data).pipe(map((response:Response)=>response))
  }
}
function toBase64(str) {
  // Encode the string as a Uint8Array
  let utf8Bytes = new TextEncoder().encode(str);
  // Create a binary string from the Uint8Array
  let binaryString = Array.from(utf8Bytes, byte => String.fromCharCode(byte)).join('');
  // Encode the binary string in Base64
  return btoa(binaryString);
}

function fromBase64(base64) {
  // Decode the Base64 string
  let binaryString = atob(base64);
  // Convert binary string to a Uint8Array
  let bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  // Decode the Uint8Array to a UTF-8 string
  return new TextDecoder().decode(bytes);
}